export const savedDataHashSelector = (state:RootState) => state.common.savedData.storage;